import type { BookPlanDefinition } from '@kitup/book-schema';
import type { Dictionary } from '../i18n/registry.js';

export interface PlanFeature {
  readonly text: string;
  readonly included: boolean;
}

/** Одинаковое сравнение тарифов на публичной странице и в конструкторе. */
export function planFeatures(
  plan: BookPlanDefinition,
  copy: Dictionary['monetization']['features'],
): readonly PlanFeature[] {
  const pageCount = plan.sceneCount * 2 + 2;

  return [
    // The builder counts spreads, the price list pages: the line says how one makes the other.
    { text: copy.pages(pageCount, plan.sceneCount), included: true },
    { text: copy.characters(plan.maxCharacters), included: true },
    { text: copy.props(plan.maxThings, plan.maxLocations), included: true },
    { text: copy.resolution(plan.imageResolution.toUpperCase()), included: true },
    plan.video.enabled
      ? { text: copy.video(plan.video.resolution), included: true }
      : { text: copy.noVideo, included: false },
    plan.narration
      ? { text: copy.narration, included: true }
      : { text: copy.noNarration, included: false },
    { text: copy.share, included: true },
    plan.printReady
      ? {
          text: plan.printQuality === 'high' ? copy.printHigh : copy.printStandard,
          included: true,
        }
      : { text: copy.noPrint, included: false },
    { text: copy.replacements(plan.freeImageReplacements, plan.video.enabled), included: true },
  ];
}
